"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HouseDetail',
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      dialogVisible: false,
      col: 6,
      basic: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    open: function open(basic) {
      this.dialogVisible = true;
      this.basic = basic;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    }
  }
};